/** The officers' dashboard, the planning section bar, the no-access page and the admins' activity view (plan F3). */
export default {
  dashboard: {
    title: 'Planning dashboard',
    subtitle: 'Submissions, checks and approvals at a glance.',
    nav: {
      label: 'Planning sections',
      dashboard: 'Dashboard',
      submissions: 'Submissions',
      mySubmissions: 'My submissions',
      registrations: 'Registrations',
      activity: 'Activity',
      settings: 'Settings',
    },
    noAccessTitle: 'No access to Planning',
    noAccessBody:
      'Your account has no Planning role. Ask an administrator to add you to a reviewer or approver group, or to approve your applicant registration.',
    noAccessHome: 'Back to Home',
    quickActions: 'Quick actions',
    newSubmission: 'New submission',
    openStaging: 'Open Peta Staging',
    openApproved: 'Open Peta Diluluskan',
    mapsMissing: 'The planning maps appear once Settings → Planning has been saved.',
    cards: {
      all: 'All submissions',
      awaiting: 'Awaiting review',
      approved: 'Approved',
      returned: 'Returned',
      failed: 'Failed check',
      withdrawn: 'Withdrawn',
    },
    conversion: 'Latest check per submission',
    conversionInProgress: 'In progress',
    conversionPassed: 'Passed',
    conversionFailed: 'Failed',
    conversionErrored: 'Could not run',
    successRate: 'Success rate',
    successRateHint: 'Passed ÷ (passed + failed). Checks that could not run are left out.',
    successRateNone: 'No finished checks yet',
    storage: 'Storage used',
    storageHint: 'Drawings and derived files; a file kept for several revisions counts once.',
    byStage: 'By stage',
    crsUsage: 'Coordinate systems',
    crsUnknown: 'EPSG {{srid}} (not in the pack)',
    none: 'None yet.',
    recent: 'Recent submissions',
    recentEmpty: 'No submissions yet.',
    viewAll: 'View all submissions',
  },
  activity: {
    title: 'Planning activity',
    subtitle:
      'Who did what in Planning, newest first. Times, IP addresses and browsers are shown where they were recorded.',
    notPermitted: 'Only a tenant administrator can view Planning activity.',
    filterLabel: 'Action',
    allActions: 'All actions',
    columns: {
      time: 'Time',
      action: 'Action',
      actor: 'By',
      target: 'Item',
      ip: 'IP address',
      userAgent: 'Browser (user agent)',
    },
    system: 'System',
    empty: 'No Planning activity has been recorded yet.',
    loadMore: 'Load more',
    loadingMore: 'Loading…',
    targets: {
      planning_case: 'Submission',
      planning_document: 'File',
      planning_registration: 'Registration',
      planning_settings: 'Settings',
      planning_import: 'Package import',
      planning_trusted_system: 'Trusted system',
    },
    actions: {
      case_created: 'Submission created',
      case_updated: 'Submission edited',
      case_submitted: 'Submitted',
      case_resubmitted: 'Resubmitted',
      case_check_retried: 'Check retried',
      case_approved: 'Approved',
      case_returned: 'Returned',
      case_withdrawn: 'Withdrawn',
      case_deleted: 'Deleted',
      document_uploaded: 'Drawing uploaded',
      document_downloaded: 'File downloaded',
      register_retried: 'Map update retried',
      registration_approved: 'Registration approved',
      registration_rejected: 'Registration rejected',
      registration_password_issued: 'Temporary password issued',
      settings_updated: 'Settings updated',
      chain_broken: 'History failed verification',
      calendar_updated: 'Working-day calendar updated',
      procedure_updated: 'Procedure adjustments saved',
      case_exported: 'Case package export requested',
      case_export_downloaded: 'Case package downloaded',
      case_authority_recalled: 'Case recalled from another system',
      seal_key_rotated: 'Package signing key replaced',
      import_validated: 'Case package checked',
      case_imported: 'Case package imported',
      case_external_id_linked: 'External reference linked',
      trusted_system_updated: 'Trusted system saved',
      trusted_system_deleted: 'Trusted system removed',
    },
  },
} as const
